import React from "react";
import Selector from "canvas-core-react/lib/Selector";
import { useTranslation } from "react-i18next";

export const VALUE_ACCOUNT_TYPE = {
  BNS: "BNS",
  LOCAL: "LOCAL",
  INT: "INT",
};

export const LABELS_ACCOUNT_TYPE = {
  BNS: "Nacional BNS",
  LOCAL: "Nacional SINPE / ACH",
  INT: "Internacional",
};

//id name value onChange placeholder
const AccountTypeSelect = ({ className = "", exclude = [], ...rest }) => {
  const { t } = useTranslation();

  const getOptions = () => {
    const options = [
      {
        key: "state-0",
        value: VALUE_ACCOUNT_TYPE.BNS,
        label: t("selects.national_bns", LABELS_ACCOUNT_TYPE.BNS),
      },
      {
        key: "state-1",
        value: VALUE_ACCOUNT_TYPE.LOCAL,
        label: t("selects.national_local", LABELS_ACCOUNT_TYPE.LOCAL),
      },
      {
        key: "state-2",
        value: VALUE_ACCOUNT_TYPE.INT,
        label: t("selects.international", LABELS_ACCOUNT_TYPE.INT),
      },
    ];

    return exclude.length
      ? options.filter((opt) => !exclude.includes(opt.value))
      : options;
  };

  return (
    <Selector
      label={t(
        "general.provider_account_detail.account_type",
        "Tipo de Cuenta"
      )}
      className={className}
      {...rest}
    >
      {getOptions().map(({ label, key, value }) => (
        <option key={key} value={value}>
          {label}
        </option>
      ))}
    </Selector>
  );
};

export default AccountTypeSelect;
